import { DisplayElementModel } from './display-element.model';
import { LayoutStyle } from './layout-style.model';

export class LayoutDisplayElement extends DisplayElementModel {

    declare styles: LayoutStyle;

    constructor(styles?: any) {
        super();
        this.isBoundToGlobalStyles = true;
        this.styles = new LayoutStyle(styles);
    }

    canRender(): boolean {
        return true;
    }

    clone(): LayoutDisplayElement {
        const clone = new LayoutDisplayElement(this.styles);
        clone.displayType = this.displayType;
        return clone;
    }

    onUpdate(): boolean {
        return false;
    }

    isEqual(other: LayoutDisplayElement): boolean {
        if (!this.styles.equals(other.styles, true)) {
            return false;
        }
        return true;
    }
}
